//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getUserList } from '@/api/api';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
export default {
  name: "SelectUserListModal",
  mixins: [JeecgListMixin],
  data: function data() {
    return {
      title: "操作",
      visible: false,
      model: {},
      confirmLoading: false,
      url: {
        add: "/act/model/create",
        list: "/sys/user/list"
      },
      columns: [{
        title: '用户账号',
        align: "center",
        dataIndex: 'username',
        fixed: 'left',
        width: 200
      }, {
        title: '用户真实姓名',
        align: "center",
        dataIndex: 'realname'
      }, {
        title: '性别',
        align: "center",
        dataIndex: 'sex_dictText'
      }, {
        title: '手机号码',
        align: "center",
        dataIndex: 'phone'
      }, {
        title: '邮箱',
        align: "center",
        dataIndex: 'email'
      }, {
        title: '状态',
        align: "center",
        dataIndex: 'status_dictText'
      }]
    };
  },
  created: function created() {
    var _this = this;

    //Step.2 加载用户数据
    getUserList().then(function (res) {
      if (res.success) {
        _this.dataSource = res.result.records;
        _this.ipagination.total = res.result.total;
      }
    });
  },
  methods: {
    open: function open() {
      this.visible = true; //Step.1 清空选中用户

      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleChange: function handleChange(info) {
      var file = info.file;

      if (file.response.success) {
        this.$message.success(file.response.message);
        this.$emit('ok');
        this.close();
      } else {
        this.$message.warn(file.response.message);
      }
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    handleSubmit: function handleSubmit() {
      this.$emit('ok', this.selectionRows);
      this.close();
    }
  }
};